import React, { useState } from 'react';
import { Box, Button, CircularProgress, Grid, IconButton, Stack, Typography } from '@mui/material';
import ScrollBox from '../../../components/ScrollBox';
import BlurImg from '../../../components/BlurImg';
import { Delete } from '@mui/icons-material';
import dummySVG from '../../../assets/svg/dummy.svg';
import { compressImage } from '../../../utils/format';
import { fileUploadService, getFileUrl } from '../../../services/s3-service';
import { notify } from '../../../components/notify';

function UploadSection({ imgArr, onUpload, onRemove }) {
    const [loading, setLoading] = useState(false);


    async function handleFileUpload(e) {
        setLoading(true);
        const files = Array.from(e.target.files);

        try {
            const uploadedFiles = [];

            for (const file of files) {
                const compressedFile = await compressImage(file);
                const fileKey = await fileUploadService(compressedFile);
                const imgUrl = await getFileUrl({ fileKey });

                uploadedFiles.push({ fileKey, fileUrl: imgUrl });
            }
            onUpload(uploadedFiles);
        } catch (error) {
            console.log(error);
            if (error === "apiError")
                notify("error", "Error in File Uploading...");
            onUpload(files.map(() => ({ fileKey: null, fileUrl: null })));
        }

        setLoading(false);
    }

    return (
        <Stack height={"100%"} width={"100%"} gap={2}>
            <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 2, height: "62%" }}>
                <Typography color="rgba(0, 0, 0, 0.5)" ml={2} mt={1} mb={0.6}>Preview</Typography>
                <ScrollBox height={"89%"}>
                    {loading ? <Stack height={"100%"} width={"100%"} alignItems={"center"} justifyContent={"center"}>
                        <CircularProgress size={50} color={"primary"} />
                    </Stack> : <Grid container spacing={3}
                        direction="row"
                        justifyContent="center"
                        alignItems="center" pt={3}
                    >
                        {imgArr.map(({ fileKey, fileUrl }, index) => (<Box key={index} sx={{
                            boxShadow: 4,
                            width: 120, height: 120, borderRadius: 4, mx: 1, mb: 1, mt: 1, display: 'flex', justifyContent: 'center',
                            alignItems: 'center', position: "relative", overflow: 'hidden', // Ensure content doesn't overflow the box
                        }}> {<>
                            <BlurImg imgUrl={fileUrl ? fileUrl : dummySVG} alt={"Category"} />
                            {fileUrl && <IconButton sx={{ position: "absolute", top: -5, right: -5 }} onClick={() => onRemove(index)}>
                                <Box bgcolor={"white"} borderRadius={100} width={25} height={25}
                                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                    <Delete color='error' sx={{ fontSize: 20 }} />
                                </Box>
                            </IconButton>}
                        </>}
                        </Box>))}
                    </Grid>}
                </ScrollBox>
            </Box>
            <Stack alignItems={'center'} justifyContent={'center'} gap={1}>
                <Button variant="contained" component="label" sx={{ bgcolor: 'rgba(53, 65, 236, 0.65)', color: 'rgba(255, 255, 255, 1)', fontSize: 12 }}>
                    Upload Photo
                    <input type="file" multiple hidden accept="image/*" onChange={handleFileUpload} />
                </Button>
                <Typography variant="caption" color="text.secondary" fontSize={10}>
                    (Maximum 7Mb)
                </Typography>
            </Stack>
        </Stack>
    );
};

export default UploadSection;



